import React from "react";
import CollectionListPresenter from "./CollectionListPresenter";
import { dialog, Button } from "../../nq-component";
import AddField from "./components/AddField";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { exportCSVUseCase } from "../../usecases/csv/usecases";
import FormCollection from "./components/FormCollection";
import DeleteCollection from "./components/DeleteCollection";
import DeleteField from "./components/DeleteField";
import { Progress, InfiniteScroll } from "../../nq-component";
import FormAccess from "./components/FormAccess";
import mergeACl from "../../mergeACl";
import withRouter from "../../withRouter";
import Search from "../../components/Search";
import BaseListPage from "../../base/BaseListPage";
import NavBar from "../../components/navbar";
import InputFactory from "../../components/InputFactory";
import browseFile from "../../browseFile";
import Table from "../../components/Table";

class CollectionListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CollectionListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
  }

  /*when class change*/
  componentDidUpdate(prevProps, prevState) {
    this.presenter.componentDidUpdate(prevProps, prevState);
  }

  closeDialog() {
    dialog.close();
  }

  onClickAddCollection() {
    // create empty schema
    dialog.fire({
      html: (
        <FormCollection
          schema={{}}
          onSubmit={(schema) => this.presenter.onSubmitAddCollection(schema)}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickEditCollection(schema) {
    dialog.fire({
      html: (
        <FormCollection
          schema={schema}
          onSubmit={(s) => this.presenter.onSubmitEditCollection(s)}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickAddField(schema) {
    const schemas = this.getSchemas();
    dialog.fire({
      html: (
        <AddField
          schema={schema}
          collections={schemas.map((s) => s.collection)}
          onSubmit={(s) => this.presenter.onSubmitEditCollection(s)}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onCLickAccess() {
    function submit(acl) {
      this.presenter.onSubmitAccess(acl);
    }

    const acl = mergeACl(this.state.selected);
    dialog.fire({
      html: (
        <FormAccess
          currentUser={this.getCurrentUser()}
          acl={acl}
          onSubmit={submit.bind(this)}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickDeleteField() {
    const schema = this.getSchema(this.getCollectionName());
    dialog.fire({
      html: (
        <DeleteField
          fields={Object.keys(schema.fields)}
          onSubmit={(f) => this.presenter.onSubmitDeleteField(f)}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickDeleteCollection() {
    const schema = this.getSchema(this.getCollectionName());
    dialog.fire({
      html: (
        <DeleteCollection
          schema={schema}
          onSubmit={() =>
            this.presenter.onSubmitDeleteCollection(schema.collection)
          }
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickImport() {
    browseFile("*").then((files) => {
      if (files.length > 0) {
        const file = files[0];
        this.presenter.onClickImport(file);
      }
    });
  }

  onClickExport() {
    this.presenter.onClickExport();
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, progress } = this.state;
    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <Search
                schemas={this.getSchemas()}
                className="mt-3"
                onSubmit={this.searchSubmit.bind(this)}
                fields={schema.fields}
              />
              <Table
                fields={schema.fields}
                objects={objects}
                // selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["acl", "password"]
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                onSort={this.onClickSort.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
        <div className="position-fixed bottom-0 end-0 m-4">
          <Button
            className="btn text-white shadow-sm"
            onClick={this.onClickAdd.bind(this)}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "25px",
              backgroundColor: "#e09552",
            }}
          >
            <i className="bi bi-plus-lg" />
          </Button>
        </div>
      </>
    );
  }
}

export default withRouter(CollectionListPage);
